import { render, staticRenderFns } from "./BillingDisabledBanner.vue?vue&type=template&id=6c7e98fe"
import script from "./BillingDisabledBanner.vue?vue&type=script&lang=js"
export * from "./BillingDisabledBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports